import React from "react";
import "./Learn.css";
import learn from "../../../../assets/images/Learn/pngwing 3.png";
import { useTranslation } from "react-i18next";
function Learn() {
  const { t } = useTranslation();

  return (
    <div className="learn">
      <div className="learn-container-1">
        <div className="learn-text-main">
          <div className="learn-text-head">
            <h2> {t("Learn without limits")}</h2>
          </div>
          <div className="learn-text-para">
            <p>
             {t(`Join M-Squared`)}
            </p>
            <p>
              {t("We, at the M-Squared Training Center, trust in the")}{" "}
              {t("importance of education as a means of")}
              <span className="text-bold">{t("empowering people")}</span>
              {t("by expanding their access to the various opportunities.")}
            </p>
            <p>
              {t("As a leading provider of")}
              {t("high-quality IT products")}
              {t("and services to")}
              {t("clients across the globe, we are committed to playing our")}
              {t(
                "part in encouraging and growing IT talent all over the world."
              )}
            </p>
          </div>
        </div>
      </div>
      <div className="learn-container-2">
        <img src={learn} className="img-learn" id="img-brain" alt="learn"/>
      </div>
    </div>
  );
}

export default Learn;
